import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Icon from "../../assets/image/icon/wizMarket_icon.png";
import { sendToApp, addAppMessageListener } from "../../bridges/appBridge";

const AdsLogin = ({ storeBusinessNumber }) => {
    const [userId, setUserId] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState(""); // 오류 메시지 상태 추가
    const navigate = useNavigate();

    useEffect(() => {
        // 1) 먼저 리스너 붙임 
        const off = addAppMessageListener((msg) => {
            const t = msg?.type;
            const p = msg?.payload || {};
            // 안드로이드 WebView에서는 console 보기 어려우니 alert로
            // 자주 오는 타입만 추려서 경고창 표시 (필요시 추가)
            if ([
                "WEB_READY_ACK", "PUSH_TOKEN", "PERMISSION_STATUS",
                "NAV_STATE_ACK", "PUSH_EVENT", "SHARE_RESULT",
                "SIGNIN_RESULT", "SIGNOUT_RESULT", "OFFLINE_FALLBACK", "TOAST"
            ].includes(t)) {
                // alert(`[APP→WEB] 리스너 ${t}\n` + JSON.stringify(p, null, 2));
            }
            // 기존 로직 유지: 토큰/설치ID 상태 반영
            if (t === "PUSH_TOKEN" || (t === "PERMISSION_STATUS" && p.token) || t === "WEB_READY_ACK") {
                const tok = p.token || "";

                localStorage.setItem("device_token", tok);
            }
        });

        // 2) 네이티브에 "리스너 준비됨" 알림 → 토큰 재전송 유도 

        sendToApp("WEB_READY", { ts: Date.now() });
        // alert("[WEB→APP] 웹 레디 WEB_READY sent");
        // sendToApp("CHECK_PERMISSION", { name: "push" });

        // 3) 이제 부트스트랩/라우팅 
        (async () => {
            try {
                const jwtFromNative = window.Android?.getToken?.();
                const jwtFromWeb = localStorage.getItem("access_token");
                const jwt = jwtFromNative || jwtFromWeb;
                if (jwt) axios.defaults.headers.common["Authorization"] = `Bearer ${jwt}`;
            } catch {
            }
        })();
        return () => off?.();
    }, []);


    const handleSubmit = async (e) => {
        e.preventDefault();
        // 로그인 요청
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/login`,
                {
                    email: userId,
                    temp_pw: password,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            );
            if (response.data.success) {
                const { user_id, type, store_business_number, login_provider } = response.data;
                const finalStoreBusinessNumber = store_business_number || storeBusinessNumber;
                localStorage.setItem("user_id", user_id);
                localStorage.setItem("store_business_number", finalStoreBusinessNumber)
                localStorage.setItem("login_provider", login_provider)
                // alert(finalStoreBusinessNumber)
                // 사용자 유형에 따라 분기 처리
                if (type === "admin") {
                    navigate("/ads/admin", { state: { type: type } });
                } else if (type === "test") {
                    navigate("/ads/main", { state: { storeBusinessNumber } });
                } else if (type === "user") {
                    try {
                        const res = await axios.get(
                            `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/login/permission`,
                            { params: { user_id } }
                        );
                        const isConfirmed = res.data?.permission_confirmed === 1;
                        if (!isConfirmed) {
                            navigate("/ads/permission", { replace: true });
                            return;
                        }
                    }
                    catch (e) {
                        console.error("permission 조회 실패", e);
                    }
                    navigate("/ads/main", { replace: true, state: { storeBusinessNumber } });
                } else {
                    setErrorMessage("지원되지 않는 사용자 유형입니다.");
                }
            }
            else {
                setErrorMessage("아이디 또는 비밀번호가 올바르지 않습니다.");
            }
        } catch (error) {
            console.error("로그인 오류:", error);
            setErrorMessage("서버 오류가 발생했습니다.");
        }
    };

    const handleSignup = () => {
        navigate(`/ads/register`);
    };


    return (
        <div className="p-8">
            <div className="w-full bg-white ">
                <div className="py-6">
                    <img
                        src={Icon}
                        alt="아이콘"
                        className=""
                    />
                </div>
                <div className="pb-12">
                    <h1 className="text-3xl font-bold pb-8">Log In</h1>
                    <h1 className="text-gray-400">로그인을 하시면 wizAD 서비스를 모두 이용하실 수 있습니다.</h1>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <input
                        type="text"
                        placeholder="이메일을 입력해주세요."
                        value={userId}
                        onChange={(e) => setUserId(e.target.value)}
                        className="w-full px-4 py-3 border border-gray-100 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                        autoComplete="username"
                    />
                    <input
                        type="password"
                        placeholder="비밀번호를 입력해주세요."
                        className="w-full px-4 py-3 border border-gray-100 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete="current-password"
                    />
                    {errorMessage && (
                        <p className="text-red-500 text-sm">{errorMessage}</p>
                    )}

                    <div className="">
                        <p className="text-center text-gray-800">
                            아직 계정이 없으신가요?{' '}
                            <button
                                type="button"
                                onClick={handleSignup}
                                className="text-[#7864F9] font-semibold hover:underline"
                            >
                                회원가입하기
                            </button>
                        </p>
                    </div>

                    <div className="flex items-center justify-center pb-8">
                        <button
                            type="submit"
                            id="auto-login-btn"
                            className="w-1/2 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                        >
                            로그인
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AdsLogin;
